module.exports = __webpack_public_path__ + "img/bag3.9d229009.jpg";